import { Component, OnInit, ViewChild, Output, Input, EventEmitter } from '@angular/core';
import { Filter } from 'models';
import { Dictionary } from 'models';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort } from '@angular/material/sort';
import { MatPaginator } from '@angular/material/paginator';
import { AreaService } from '#services/api/area.service';
import { ToasterService } from '#services/shared';
import { MatDialog } from '@angular/material/dialog';
import { AreaEditArgs, AreaEditDialogComponent } from '../area-edit-dialog/area-edit-dialog.component';
import { Role } from 'enums';
import { ConfirmationDialogComponent } from '#components/shared/confirmation-dialog/confirmation-dialog.component';
import { Page } from '_interfaces/page';

@Component({
  selector: 'area-table',
  templateUrl: './area-table.component.html',
  styleUrls: ['./area-table.component.scss'],
  standalone: false
})
export class AreaTypeTableComponent implements OnInit {
  @Input()
  set filter(value: Filter) {
    this._filter = value;

    this.applyFilter(value);
  }
  get filter() {
    return this._filter;
  }

  @Input()
  set data(value: Dictionary[]) {
    this.dataSource.data = value;
  }

  @Input() columnsToDisplay: Map<string, string>;
  @Output() collectionChanged = new EventEmitter();

  @ViewChild(MatPaginator)
  paginator: MatPaginator;

  @ViewChild(MatSort)
  set content(sort: MatSort) {
    this.dataSource.sort = sort;
  }

  _filter: Filter = <Filter>{};
  dataSource = new MatTableDataSource<Dictionary>();

  Role = Role;

  constructor(
    public dialog: MatDialog,
    private areaService: AreaService,
    private toaster: ToasterService
  ) { }

  ngOnInit() {
    setTimeout(() => this.dataSource.paginator = this.paginator);
  }

  get allColumns(): string[] {
    return Array.from(this.columnsToDisplay.keys());
  }

  get canShowTable() {
    const hasSearchedItems = this.filter.search
      ? this.dataSource.filteredData.length
      : true;

    const hasFilterParamsItems = this.filter.paramsCount
      ? this.dataSource.data.length
      : true;

    return hasSearchedItems && hasFilterParamsItems;
  }

  getColumnTitle(column: string): string {
    return this.columnsToDisplay.get(column);
  }

  applyFilter(filter: Filter) {
    this.dataSource.filter = filter.search;

    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }

  reloadSource(areas: Dictionary[]) {
    this.data = areas;
    this.dataSource.data = this.data;
  }

  async onEditArea(area: Dictionary) {
    const args: AreaEditArgs = {
      area
    };
    const dialogRef = this.dialog.open(AreaEditDialogComponent, {
      width: '50%',
      maxHeight: '80%',
      data: args
    });

    dialogRef.afterClosed().subscribe(async (result: Dictionary) => {
      if (result) {
        const res = await this.areaService.update(result).toPromise();
        this.collectionChanged.emit({ value: res });
        this.toaster.showSuccess('Success...', 'Area has been updated.');
      }
    });
  }

  onDeleteArea(area: Dictionary) {
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      minWidth: '350px',
      minHeight: '200px',
      data: <Page>{
        pageTitle: 'Confirmation',
        pageDescription: `Are you sure you want to delete area "${area['Name']}"?`
      }
    });

    dialogRef.afterClosed().subscribe(async (result: any) => {
      if (result) {
        await this.areaService.delete(area.ID).toPromise();
        this.collectionChanged.emit({ value: area });
        this.toaster.showSuccess('Success...', 'Area has been deleted.');
      }
    });
  }
}
